import { lazy, type Component } from 'solid-js';
import { Router, Route } from '@solidjs/router';
import { QueryClient, QueryClientProvider } from '@tanstack/solid-query';
import { AppShell } from '~/components/layout/AppShell';
import { ToastViewport } from '~/components/ui/Toast';
import { getSession } from '~/stores/auth';

const HomeRoute = lazy(() => import('~/routes/HomeRoute').then((m) => ({ default: m.HomeRoute })));
const SignInRoute = lazy(() => import('~/routes/SignInRoute').then((m) => ({ default: m.SignInRoute })));
const OnboardingRoute = lazy(() => import('~/routes/OnboardingRoute').then((m) => ({ default: m.OnboardingRoute })));
const ProfileRoute = lazy(() => import('~/routes/ProfileRoute').then((m) => ({ default: m.ProfileRoute })));
const PlanListRoute = lazy(() => import('~/routes/PlanListRoute').then((m) => ({ default: m.PlanListRoute })));
const PlanNewRoute = lazy(() => import('~/routes/PlanNewRoute').then((m) => ({ default: m.PlanNewRoute })));
const PlanViewRoute = lazy(() => import('~/routes/PlanViewRoute').then((m) => ({ default: m.PlanViewRoute })));
const FamilyRoute = lazy(() => import('~/routes/FamilyRoute').then((m) => ({ default: m.FamilyRoute })));
const PantryRoute = lazy(() => import('~/routes/PantryRoute').then((m) => ({ default: m.PantryRoute })));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, gcTime: 5 * 60 * 1000, retry: 1, refetchOnWindowFocus: true },
  },
});

// Probe the session once on boot; the auth store dedups concurrent callers.
void getSession();

const Layout: Component<{ children?: unknown }> = (props) => (
  <AppShell>{props.children as never}</AppShell>
);

export const App: Component = () => (
  <QueryClientProvider client={queryClient}>
    <Router root={Layout}>
      <Route path="/" component={HomeRoute} />
      <Route path="/signin" component={SignInRoute} />
      <Route path="/onboarding" component={OnboardingRoute} />
      <Route path="/profile" component={ProfileRoute} />
      <Route path="/plan" component={PlanListRoute} />
      <Route path="/plan/new" component={PlanNewRoute} />
      <Route path="/plan/:id" component={PlanViewRoute} />
      <Route path="/family" component={FamilyRoute} />
      <Route path="/pantry" component={PantryRoute} />
    </Router>
    <ToastViewport />
  </QueryClientProvider>
);
